<template>
  <v-container>
    <v-row class="text-center">
      <v-snackbar v-model="snackbar" :timeout="timeout" color="red">
        {{ $t("obbligatori") }}
      </v-snackbar>
      <v-col cols="12">
        <v-alert border="top" dense colored-border elevation="2" v-if="e1 > 0">
          <div class="text-h6">
            <!--{{ $t("message") }}-->
            <v-alert
              type="error"
              color="#B71C1C"
              dark
              class="text-decoration-underline"
            >
              {{ $t("avviso") }}
            </v-alert>
          </div>
        </v-alert>

        <v-card>
          <v-alert border="top" dense colored-border elevation="2">
            Ref. Airbnb:
            <v-chip class="ma-2" color="black" label text-color="white">
              {{ riepilogo.refAIRBNB }}
            </v-chip>
            {{ $t("ospite") }}:
            <v-chip class="ma-2" color="black" label text-color="white">
              {{ riepilogo.refGuest }}
            </v-chip>
          </v-alert>
          <v-card-text class="grey lighten-4">
            <v-sheet class="mx-auto">
              <!--stepper-->
              <v-stepper v-model="e1">
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 0" step="0">
                    {{ $t("intro") }}
                  </v-stepper-step>

                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 1" step="1">
                    {{ $t("ospite") }} n.1 (Group Leader)
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" step="2">
                    {{ $t("ospite") }} n.2
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 3" step="3">
                    {{ $t("ospite") }} n.3
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 4" step="4">
                    {{ $t("ospite") }} n.4
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 5" step="5">
                    {{ $t("ospite") }} n.5
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="0">
                    <v-card class="mb-12" color="grey lighten-5">
                      <OraArrivo></OraArrivo>
                    </v-card>

                    <v-btn color="primary" @click.native="submitFormOrario()">
                      {{ $t("continua") }}
                    </v-btn>
                  </v-stepper-content>
                  <v-stepper-content step="1">
                    <v-card class="mb-12" color="grey lighten-5">
                      <anagrafica1
                        :tipo="$t('ospite') + ' n.1 (Group Leader)'"
                      />
                    </v-card>

                    <v-btn text @click="e1 = 0"> {{ $t("indietro") }} </v-btn>
                    <v-btn color="primary" @click.native="submitForm()">
                      {{ $t("continua") }}
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-card class="mb-12" color="grey lighten-5">
                      <anagrafica2 :tipo="$t('ospite') + ' n.2'" />
                    </v-card>

                    <v-btn color="primary" @click="e1 = 3">
                      {{ $t("continua") }}</v-btn
                    >

                    <v-btn text @click="e1 = 1"> {{ $t("indietro") }} </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-card class="mb-12" color="grey lighten-5">
                      <anagrafica3 :tipo="$t('ospite') + ' n.3'" />
                    </v-card>

                    <v-btn color="primary" @click="e1 = 4">
                      {{ $t("continua") }}
                    </v-btn>

                    <v-btn text @click="e1 = 2"> {{ $t("indietro") }} </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="4">
                    <v-card class="mb-12" color="grey lighten-5">
                      <anagrafica4 :tipo="$t('ospite') + ' n.4'" />
                    </v-card>

                    <v-btn color="primary" @click="e1 = 5">
                      {{ $t("continua") }}
                    </v-btn>

                    <v-btn text @click="e1 = 3"> {{ $t("indietro") }} </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="5">
                    <v-card class="mb-12" color="grey lighten-5">
                      <anagrafica5 :tipo="$t('ospite') + ' n.5'" />
                    </v-card>

                    <v-btn color="primary" @click="inviadati()">
                      {{ $t("inviadati") }}
                    </v-btn>

                    <v-btn text @click="e1 = 4"> {{ $t("indietro") }} </v-btn>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
              <!--fine stepper-->
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>

      <!--{{ $store.state.riepilogo }}-->
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import OraArrivo from "@/components/OraArrivo.vue";
import Anagrafica1 from "@/components/Anagrafica1.vue";
import Anagrafica2 from "@/components/Anagrafica2.vue";
import Anagrafica3 from "@/components/Anagrafica3.vue";
import Anagrafica4 from "@/components/Anagrafica4.vue";
import Anagrafica5 from "@/components/Anagrafica5.vue";
export default {
  name: "HelloWorld",
  components: {
    OraArrivo,
    Anagrafica1,
    Anagrafica2,
    Anagrafica3,
    Anagrafica4,
    Anagrafica5,
  },
  data: () => ({
    nazioni: [],
    e1: 0,
    snackbar: false,
    timeout: 2000,
  }),
  mounted() {
    this.datiPrenotazione();
    this.caricaNazioni();
  },
  computed: {
    riepilogo() {
      return this.$store.state.riepilogo;
    },
  },
  methods: {
    datiPrenotazione() {
      axios
        .get(
          `https://api.digisistemi.it/suite23/checkRef/` + this.$route.query.ref
        )
        .then((response) => {
          var dati = response.data;
          //alert(JSON.stringify(dati));
          // se il ref non è buono BLOCCO TUTTO
          if (dati.totale == 0 || dati.COMPILATO == 1) {
            this.$swal({
              title: this.$t("attenzione"),
              text: this.$t("blocco"),
              icon: "error",
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              //alert("esco");
            });
          } else {
            this.$store.state.riepilogo.ref = dati.ID;
            this.$store.state.riepilogo.refGuest = dati.REFERENTE;
            this.$store.state.riepilogo.refAIRBNB = dati.CODICEAIRBNB;
          }
        })
        .catch((e) => {
          alert(e);
        });
    },
    caricaNazioni() {
      axios
        .get(`https://api.digisistemi.it/suite23/getNazioni`)
        .then((response) => {
          this.$store.state.nazioni = response.data;
        })
        .catch((e) => {
          alert(e);
        });
    },
    inviadati() {
      this.$swal({
        title: this.$t("richiestaconferma"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("confermainvio"),
      }).then((result) => {
        if (result.isConfirmed) {
          // QUI va la chiamta per il save dei dati tramite api
          axios
            .post(
              `https://api.digisistemi.it/suite23/insertGuest`,
              this.riepilogo
            )
            .then((response) => {
              // se tutto ok (codice 200) confermo
              if (response.status == 200) {
                this.$swal({
                  title: this.$t("inviotitolo"),
                  text: this.$t("inviotesto"),
                  icon: "success",
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                }).then(() => {
                  //alert("esco");
                });
              }
              // in caso contrario do errore
              else {
                this.$swal(
                  this.$t("attenzione"),
                  this.$t("erroreinsert"),
                  "error"
                );
              }
            })
            .catch((e) => {
              alert(e);
            });
          //
        }
      });
    },
    submitForm() {
      if (
        this.$store.state.riepilogo.ospite1.nome != "" &&
        this.$store.state.riepilogo.ospite1.cittadinanza != "" &&
        this.$store.state.riepilogo.ospite1.luogonascita != "" &&
        this.$store.state.riepilogo.ospite1.cognome != "" &&
        this.$store.state.riepilogo.ospite1.datanascita != "" &&
        this.$store.state.riepilogo.ospite1.sesso != "" &&
        this.$store.state.riepilogo.ospite1.luogorilascio != "" &&
        this.$store.state.riepilogo.ospite1.tipodocumento != "" &&
        this.$store.state.riepilogo.ospite1.numerodocumento != ""
      ) {
        this.e1++;
      } else {
        this.snackbar = true;
      }
    },
    submitFormOrario() {
      if (
        this.$store.state.riepilogo.OraArrivo != "" &&
        this.$store.state.riepilogo.OraArrivo != null
      ) {
        this.e1++;
      } else {
        this.snackbar = true;
      }
    },
    goBack() {
      this.e1--;
    },
  },
};
</script>
